export default "__VITE_ASSET__cd30b717__"